module.exports = __webpack_public_path__ + "img/15.af298106.png";